import React from 'react';
import { Container } from '@mui/material';
import Layout from '../../components/Layout';
import DriverScheduleSection from '../../components/manager/DriverScheduleSection';

const DriverSchedule = () => (
  <Layout>
    <Container maxWidth="lg">
      <DriverScheduleSection selfView />
    </Container>
  </Layout>
);

export default DriverSchedule;
